import React from "react";
import { FormGroup, FormLabel, Button } from "react-bootstrap";

import "../styles.css";

const ButtonInput = ({
  id,
  label = "",
  buttonText,
  onButtonClick,
  variant,
  width,
}) => {
  return (
    <div style={{ width: width }}>
      <FormGroup style={{ display: "grid" }}>
        <FormLabel htmlFor={`btn-${id}`}>{label}</FormLabel>
        <Button
          type="text"
          id={`btn-${id}`}
          onClick={onButtonClick}
          name={id}
          variant={variant}
        >
          {buttonText}
        </Button>
      </FormGroup>
    </div>
  );
};

export default ButtonInput;
